import { render, staticRenderFns } from "./CollectionSettings.vue?vue&type=template&id=749d8bc8&scoped=true"
import script from "./CollectionSettings.vue?vue&type=script&lang=js"
export * from "./CollectionSettings.vue?vue&type=script&lang=js"
import style0 from "./CollectionSettings.vue?vue&type=style&index=0&id=749d8bc8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "749d8bc8",
  null
  
)

export default component.exports